import { Component, Input, OnInit } from "@angular/core";
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { ReplaySubject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Globals } from "src/app/common/globals";
import {
  ScheduleItem,
  TimeItem,
} from "src/app/modules/components/datepicker/datepicker.component";
import {
  ExperienceStepModel,
  GeneralExpWizardInfoByLang,
} from "src/app/models/experience-steps.model";
import { ErrorEmitterService } from "src/app/services/emitters/error-emitter.service";
import { LANGUAGE } from "src/app/services/experience/experience-steps.service";
import { ExperiencesService } from "src/app/services/experience/experiences.service";
import { SavingEmitterService } from "src/app/services/emitters/saving-emitter.service";
import { TimeService } from "src/app/services/generic/time.service";

interface GeneralInfoStepValidationError {}

@Component({
  selector: "app-general-information-step",
  templateUrl: "./general-information-step.component.html",
  styleUrls: ["./general-information-step.component.scss"],
})
export class GeneralInformationStepComponent implements OnInit {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  LANGUAGE = LANGUAGE;

  @Input() step: ExperienceStepModel;
  @Input() generalInfoByLang: GeneralExpWizardInfoByLang;
  @Input() experienceId: string;
  @Input() hasIssue: boolean;
  @Input() comments: Array<any>;
  @Input() commentSchedule: boolean;
  @Input() commentInfo: boolean;
  @Input() experienceOrigin: boolean;
  @Input() experienceOriginUrl: string;

  public categories: Array<any> = Globals.categories;

  public selectedSchedule: any;
  public selectedScheduleIndex: number;
  public loadedExperinceSchedules: Array<any> = [];

  public startTime: string;
  public endTime: string;
  public startTimeIso: string;
  public endTimeIso: string;
  public hoveredDate: NgbDate;
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public timeFrom: any = { hour: 10, minute: 30 };
  public timeTo: any = { hour: 15, minute: 30 };

  public weekDays: Array<number> = [1, 2, 3, 4, 5, 6, 7];
  public weekDaysStringHolder: Array<any> = [];
  public weekDayString: Array<any> = Globals.weekDayString;

  private editSchedule: any;
  public editScheduleIsLoaded = false;
  public toogleDatepicker: boolean = false;

  public errorName: boolean;
  public errorDesc: boolean;

  constructor(
    private calendar: NgbCalendar,
    private timeSvc: TimeService,
    private experienceSvc: ExperiencesService,
    private savingEmitter: SavingEmitterService,
    private errorEmitter: ErrorEmitterService
  ) {}

  ngOnInit(): void {
    this.checkStepComplete();
  }

  changeTitle(event: any) {
    if (event.target.value == null || event.target.value === "") {
      this.errorName = true;
      this.checkStepComplete();
    } else {
      this.errorName = false;
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language].title =
        event.target.value;
      this.addExperienceInfo();
    }
  }

  changeDesc(event: any) {
    if (event.target.value == null || event.target.value === "") {
      this.errorDesc = true;
      this.checkStepComplete();
    } else {
      this.errorDesc = false;
      this.generalInfoByLang.dataByLang[
        this.generalInfoByLang.language
      ].description = event.target.value;
      this.addExperienceInfo();
    }
  }

  selectExperienceType(type: string, i: number) {
    if (
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .typeIndex === i
    ) {
      return;
    }
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].typeIndex = i;

    this.experienceSvc
      .setExperienceType(this.experienceId, type)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.savingEmitter.sendMessage(false);
          this.checkStepComplete();
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  changeLanguage(lang: string) {
    this.generalInfoByLang.language = lang;
    this.checkStepComplete();
  }

  public addExperienceInfo() {
    if (
      !this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .title ||
      !this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .description
    ) {
      return;
    }

    this.savingEmitter.sendMessage(true);
    this.experienceSvc
      .addExperienceInformation(
        this.experienceId,
        this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
          .title,
        this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
          .description,
        this.generalInfoByLang.language
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.savingEmitter.sendMessage(false);
          this.checkStepComplete();
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  // Schedule logic
  selectSchedule(schedule, i) {
    this.resetPicker();
    this.selectedScheduleIndex = i;
    this.weekDays = [];
    this.clearDays();
    this.fromDate = schedule.startDateNgb;
    this.toDate = schedule.endDateNgb;
    this.timeFrom = {
      hour: new Number(
        schedule.startHour
          .substring(0, schedule.startHour.indexOf(":"))
          .replace(/^0+/, "")
      ).valueOf(),
      minute: new Number(
        schedule.startHour.substring(schedule.startHour.indexOf(":") + 1)
      ).valueOf(),
    };
    this.timeTo = {
      hour: new Number(
        schedule.endHour
          .substring(0, schedule.endHour.indexOf(":"))
          .replace(/^0+/, "")
      ).valueOf(),
      minute: new Number(
        schedule.endHour.substring(schedule.endHour.indexOf(":") + 1)
      ).valueOf(),
    };
    this.toogleDatepicker = true;

    for (let x = 0, len = schedule.weekDays.length; x < len; x++) {
      let index = this.weekDayString.findIndex(
        (item) => item.fullName === schedule.weekDays[x]
      );
      if (index == -1) {
        let emptyIndex = schedule.weekDays[x];
        this.weekDayString[emptyIndex - 1].clicked = true;
        this.weekDays.push(this.weekDayString[emptyIndex].number);
      } else {
        this.weekDayString[index].clicked = true;
        this.weekDays.push(this.weekDayString[index].number);
      }
    }
    this.editSchedule = {
      weekdays: this.weekDays,
      startDate: this.timeSvc.dateIsoTransform(schedule.startDateNgb),
      endDate: this.timeSvc.dateIsoTransform(schedule.endDateNgb),
      startTime: schedule.startHourIso,
      endTime: schedule.endHourIso,
    };
  }

  removeSchedule(schedule, i) {
    this.selectedScheduleIndex = i;
    this.savingEmitter.sendMessage(true);
    this.weekDays = [];
    this.fromDate = schedule.startDateNgb;
    this.toDate = schedule.endDateNgb;
    this.startTime = schedule.startHour;
    this.endTime = schedule.endHour;
    this.weekDaysStringHolder = schedule.weekDays;
    for (let x = 0, len = schedule.weekDays.length; x < len; x++) {
      let index = this.weekDayString.findIndex(
        (item) => item.fullName === schedule.weekDays[x]
      );
      if (index == -1) {
        let emptyIndex = schedule.weekDays[x];
        this.weekDayString[emptyIndex - 1].clicked = true;
        this.weekDays.push(this.weekDayString[emptyIndex - 1].number);
      } else {
        this.weekDayString[index].clicked = true;
        this.weekDays.push(this.weekDayString[index].number);
      }
    }
    this.selectedSchedule = {
      weekdays: this.weekDays,
      startDate: this.timeSvc.dateIsoTransform(schedule.startDateNgb),
      endDate: this.timeSvc.dateIsoTransform(schedule.endDateNgb),
      startTime: schedule.startHourIso,
      endTime: schedule.endHourIso,
    };
    this.experienceSvc
      .removeSchedule(this.experienceId, this.selectedSchedule)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.generalInfoByLang.dataByLang[
            this.generalInfoByLang.language
          ].scheduleExperience.splice(this.selectedScheduleIndex, 1);
          this.savingEmitter.sendMessage(false);
          this.checkStepComplete();
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
    this.resetPicker();
    this.toogleDatepicker = false;
  }

  onClickDoneSchedule(scheduleItem: ScheduleItem) {
    if (this.editSchedule != null) {
      this.editScheduleIsLoaded = true;
      this.experienceSvc
        .removeSchedule(this.experienceId, this.editSchedule)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(
          (x) => {
            this.editSchedule = null;

            this.generalInfoByLang.dataByLang[
              this.generalInfoByLang.language
            ].scheduleExperience.splice(this.selectedScheduleIndex, 1);
            this.sentSchedule(scheduleItem);
            this.checkStepComplete();
          },
          (err) => {
            this.errorEmitter.sendError(true);
          }
        );
    } else {
      this.sentSchedule(scheduleItem);
    }
  }

  sentSchedule(scheduleItem: ScheduleItem) {
    this.selectNewTime(scheduleItem.timeFrom, scheduleItem.timeTo);

    let startMonthString = this.timeSvc.monthsLocalizedArray(
      scheduleItem.fromDate.month - 1,
      "en"
    );
    let endMonthString = this.timeSvc.monthsLocalizedArray(
      scheduleItem.toDate.month - 1,
      "en"
    );
    for (let x = 0, len = scheduleItem.weekDays.length; x < len; x++) {
      let index = this.weekDayString.findIndex(
        (item) => item.number === scheduleItem.weekDays[x]
      );
      if (index == -1) {
      } else {
        this.weekDaysStringHolder.push(this.weekDayString[index].fullName);
      }
    }
    this.generalInfoByLang.dataByLang[
      this.generalInfoByLang.language
    ].scheduleExperience.unshift({
      startHourIso: this.startTimeIso,
      endHourIso: this.endTimeIso,
      startHour:
        scheduleItem.timeFrom.hour + ":" + scheduleItem.timeFrom.minute,
      endHour: scheduleItem.timeTo.hour + ":" + scheduleItem.timeTo.minute,
      startDate: scheduleItem.fromDate.day + " " + startMonthString,
      endDate: scheduleItem.toDate.day + " " + endMonthString,
      weekDays: this.weekDaysStringHolder,
      startDateDay: scheduleItem.fromDate.day,
      startDateMonth: startMonthString,
      endDateDay: scheduleItem.toDate.day,
      endDateMonth: endMonthString,
      startDateNgb: scheduleItem.fromDate,
      endDateNgb: scheduleItem.toDate,
    });

    this.scheduleExperience(
      this.experienceId,
      scheduleItem.weekDays,
      this.timeSvc.dateIsoTransform(scheduleItem.fromDate),
      this.timeSvc.dateIsoTransform(scheduleItem.toDate),
      this.startTimeIso,
      this.endTimeIso
    );
    this.resetPicker();

    this.editScheduleIsLoaded = false;
    this.toogleDatepicker = false;
  }

  public scheduleExperience(
    id,
    weekdays,
    startDate,
    endDate,
    startTime,
    endTime
  ) {
    this.savingEmitter.sendMessage(true);

    var startTimeAsDate = new Date(startTime);
    var startTimeHours = startTimeAsDate.getHours();
    var startTimeMinutes = startTimeAsDate.getMinutes();

    var startDateAsDate = new Date(startDate);
    var startDateYear = startDateAsDate.getFullYear();
    var startDateMonth = startDateAsDate.getMonth();
    var startDateDate = startDateAsDate.getDate();

    startDate = new Date(
      startDateYear,
      startDateMonth,
      startDateDate,
      startTimeHours,
      startTimeMinutes,
      0,
      0
    ).toISOString();

    var endTimeAsDate = new Date(endTime);
    var endTimeHours = endTimeAsDate.getHours();
    var endTimeMinutes = endTimeAsDate.getMinutes();

    var endDateAsDate = new Date(endDate);
    var endDateYear = endDateAsDate.getFullYear();
    var endDateMonth = endDateAsDate.getMonth();
    var endDateDate = endDateAsDate.getDate();

    endDate = new Date(
      endDateYear,
      endDateMonth,
      endDateDate,
      endTimeHours,
      endTimeMinutes,
      0,
      0
    ).toISOString();

    this.experienceSvc
      .scheduleExperience(id, weekdays, startDate, endDate)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        (x) => {
          this.savingEmitter.sendMessage(false);
          this.checkStepComplete();
        },
        (err) => {
          this.errorEmitter.sendError(true);
        }
      );
  }

  selectNewTime(timeFrom: TimeItem, timeTo: TimeItem) {
    this.startTimeIso =
      "0001-01-01T" +
      ("0" + timeFrom.hour).slice(-2) +
      ":" +
      ("0" + timeFrom.minute).slice(-2) +
      ":00";

    this.endTimeIso =
      "0001-01-01T" +
      ("0" + timeTo.hour).slice(-2) +
      ":" +
      ("0" + timeTo.minute).slice(-2) +
      ":00";
  }

  onClickAddNewSchedule() {
    this.editSchedule = null;
    this.resetPicker();
    this.showPicker();
  }

  showPicker() {
    this.toogleDatepicker = true;
  }

  clearDays() {
    for (let x = 0, len = this.weekDayString.length; x < len; x++) {
      this.weekDayString[x].clicked = false;
    }
  }

  resetPicker() {
    this.startTime = "";
    this.endTime = "";
    this.endTimeIso = "";
    this.startTimeIso = "";
    this.weekDays = [1, 2, 3, 4, 5, 6, 7];
    this.fromDate = this.calendar.getToday();
    this.toDate = null;
    this.timeFrom = { hour: 1, minute: 30 };
    this.timeTo = { hour: 15, minute: 30 };
    this.weekDaysStringHolder = [];
    this.weekDayString.forEach((a) => {
      a.clicked = true;
    });
  }

  checkStepComplete() {
    if (
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .title &&
      !this.errorName &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .description &&
      !this.errorDesc &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .description &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .typeIndex != null &&
      this.generalInfoByLang.dataByLang[this.generalInfoByLang.language]
        .scheduleExperience.length > 0
    ) {
      this.step.isComplete = true;
    } else {
      this.step.isComplete = false;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
